import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="nh-container py-24 text-center">
        <div className="inline-block h-8 w-8 border-4 border-black border-t-transparent rounded-full animate-spin"/>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace/>;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace/>;
  return children;
}
